// extracted by mini-css-extract-plugin
export var dropdownButton = "_1u-0";
export var fullWidthDropdownButton = "_1u-1";
export var icon = "_1u-3";
export var iconPlaceholder = "_1u-2";
export var menuItemRow = "_1u-8";
export var separator = "_1u-c";
export var shortcutContainer = "_1u-7";
export var shortcutIconLg = "_1u-6";
export var shortcutIconMd = "_1u-5";
export var shortcutIconSm = "_1u-4";
export var submenuChevron = "_1u-b";
export var submenuDropdown = "_1u-9";
export var submenuTriggerRow = "_1u-a";